import { useTranslation } from 'react-i18next'

export default function MarqueeBand() {
  const { t } = useTranslation()
  const items = t('marquee.items', { returnObjects: true }) as string[]
  const loopItems = [...items, ...items]

  return (
    <div className="w-full bg-primary-500 py-4 overflow-hidden">
      <div className="flex w-max animate-marquee">
        {loopItems.map((item, index) => (
          <div key={`${item}-${index}`} className="flex items-center px-6">
            <span className="font-heading text-lg md:text-xl text-background-50 whitespace-nowrap">
              {item}
            </span>
            <i className="ri-camera-lens-line text-background-50/70 text-lg ml-6" />
          </div>
        ))}
      </div>
    </div>
  )
}